import { secondsToTimelineTime } from '~/Util'
import ProjectAsset from '~/models/ProjectData/ProjectAsset'

/**
 * @memberOf ProjectData
 * @extends ProjectData.ProjectAudioAsset
 *
 */

class ProjectAudioAsset extends ProjectAsset {

  constructor(jsonData) {
    const {
      volume,
      muted,
      mediaFileDuration,
      mediaPlayerDuration,
      fadeInDuration = secondsToTimelineTime(3),
      fadeOutDuration = secondsToTimelineTime(3),
      fadeInIsActive = false,
      fadeOutIsActive = false,
    } = jsonData
    super(jsonData)

    this._volume = volume
    this._muted = muted
    this._mediaFileDuration = mediaFileDuration
    this._fadeInDuration = fadeInDuration
    this._fadeOutDuration = fadeOutDuration
    this._mediaPlayerDuration = mediaPlayerDuration || mediaFileDuration
    this._fadeInDuration = fadeInDuration
    this._fadeOutDuration = fadeOutDuration
    this._fadeInIsActive = fadeInIsActive
    this._fadeOutIsActive = fadeOutIsActive
  }

  get volume() {
    return this._volume
  }

  /**
   * @param {number} volume
   */
  set volume(volume) {
    this._volume = volume
  }

  get muted() {
    return this._muted
  }

  /**
   * @param {boolean} muted
   */
  set muted(muted) {
    this._muted = muted
  }

  get mediaFileDuration() {
    return this._mediaFileDuration
  }

  /**
   * @param {number} mediaFileDuration
   */
  set mediaFileDuration(mediaFileDuration) {
    this._mediaFileDuration = mediaFileDuration
  }

  get mediaPlayerDuration() {
    return this._mediaPlayerDuration
  }

  /**
   * @param {number} mediaFileDuration
   */
  set mediaPlayerDuration(duration) {
    this._mediaPlayerDuration = duration
  }


  // ---
  /**
   * @returns {number} 100-nanoseconds units
   */
  get fadeInDuration() {
    return this._fadeInDuration
  }

  /**
   * @param {number} duration
   */
  set fadeInDuration(duration) {
    this._fadeInDuration = duration
  }

  /**
   * @returns {number} 100-nanoseconds units
   */
  get fadeOutDuration() {
    return this._fadeOutDuration
  }

  /**
   * @param {number} duration
   */
  set fadeOutDuration(duration) {
    this._fadeOutDuration = duration
  }

  // ---
  /**
   * @returns {boolean}
   */
  get fadeInIsActive() {
    return this._fadeInIsActive
  }

  /**
   * @param {boolean} isActive
   */
  set fadeInIsActive(isActive) {
    this._fadeInIsActive = isActive
  }


  // ---
  /**
   * @returns {boolean}
   */
  get fadeOutIsActive() {
    return this._fadeOutIsActive
  }

  /**
   * @param {boolean} isActive
   */
  set fadeOutIsActive(isActive) {
    this._fadeOutIsActive = isActive
  }

}

export default ProjectAudioAsset
